// Kalender-Konstanten für ZielplanungsKalender
// Ausgelagert im Rahmen des Phase-1-Refactorings (März 2026)

export const MONTHS_DE = [
  "Januar", "Februar", "März", "April", "Mai", "Juni",
  "Juli", "August", "September", "Oktober", "November", "Dezember"
];

export const DAYS_SHORT = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
export const HOURS = Array.from({ length: 24 }, (_, i) => i);
export const HOUR_HEIGHT = 64;

// Color palette for appointments - user can select from these
export const APPOINTMENT_COLORS = {
  blue: { bg: 'bg-blue-500', bgHover: 'hover:bg-blue-600', text: 'text-white', light: 'bg-blue-100', lightText: 'text-blue-700', lightHover: 'hover:bg-blue-200', hex: '#3b82f6' },
  yellow: { bg: 'bg-yellow-400', bgHover: 'hover:bg-yellow-500', text: 'text-yellow-900', light: 'bg-yellow-100', lightText: 'text-yellow-700', lightHover: 'hover:bg-yellow-200', hex: '#facc15' },
  purple: { bg: 'bg-purple-500', bgHover: 'hover:bg-purple-600', text: 'text-white', light: 'bg-purple-100', lightText: 'text-purple-700', lightHover: 'hover:bg-purple-200', hex: '#a855f7' },
  cyan: { bg: 'bg-cyan-500', bgHover: 'hover:bg-cyan-600', text: 'text-white', light: 'bg-cyan-100', lightText: 'text-cyan-700', lightHover: 'hover:bg-cyan-200', hex: '#06b6d4' },
  pink: { bg: 'bg-pink-500', bgHover: 'hover:bg-pink-600', text: 'text-white', light: 'bg-pink-100', lightText: 'text-pink-700', lightHover: 'hover:bg-pink-200', hex: '#ec4899' },
  orange: { bg: 'bg-orange-500', bgHover: 'hover:bg-orange-600', text: 'text-white', light: 'bg-orange-100', lightText: 'text-orange-700', lightHover: 'hover:bg-orange-200', hex: '#f97316' },
  teal: { bg: 'bg-teal-500', bgHover: 'hover:bg-teal-600', text: 'text-white', light: 'bg-teal-100', lightText: 'text-teal-700', lightHover: 'hover:bg-teal-200', hex: '#14b8a6' },
  red: { bg: 'bg-red-500', bgHover: 'hover:bg-red-600', text: 'text-white', light: 'bg-red-100', lightText: 'text-red-700', lightHover: 'hover:bg-red-200', hex: '#ef4444' },
};

// Color keys in order for selection - blue first for multi-day
export const COLOR_KEYS = ['blue', 'yellow', 'purple', 'cyan', 'pink', 'orange', 'teal', 'red'];
export const MULTIDAY_COLOR_ORDER = ['blue', 'purple', 'cyan', 'pink', 'orange', 'teal', 'red', 'yellow'];

// Default colors: blue for multi-day, yellow for single-day
export const DEFAULT_MULTIDAY_COLOR = 'blue';
export const DEFAULT_SINGLEDAY_COLOR = 'yellow';

// Get appointment color - respects user selection or uses defaults
// For single-day: returns light/pastel colors. For multi-day: returns solid colors
export const getAppointmentColor = (appointment, multiDayIndex = 0) => {
  const isMultiDay = appointment?.isMultiDay ||
    (appointment?.from && appointment?.to && appointment.from !== appointment.to) ||
    (appointment?.date && appointment?.endDate && appointment.date !== appointment.endDate);

  if (appointment?.color && APPOINTMENT_COLORS[appointment.color]) {
    const colorData = APPOINTMENT_COLORS[appointment.color];
    if (isMultiDay) {
      return colorData;
    } else {
      return {
        ...colorData,
        bg: colorData.light,
        bgHover: colorData.lightHover,
        text: colorData.lightText
      };
    }
  }

  if (isMultiDay) {
    const colorKey = MULTIDAY_COLOR_ORDER[multiDayIndex % MULTIDAY_COLOR_ORDER.length];
    return APPOINTMENT_COLORS[colorKey];
  }

  const colorData = APPOINTMENT_COLORS[DEFAULT_SINGLEDAY_COLOR];
  return {
    ...colorData,
    bg: colorData.light,
    bgHover: colorData.lightHover,
    text: colorData.lightText
  };
};

// Legacy function for compatibility
export const getAppointmentColorByID = (id, appointment = null, multiDayIndex = 0) => {
  if (appointment) return getAppointmentColor(appointment, multiDayIndex);
  return APPOINTMENT_COLORS[DEFAULT_SINGLEDAY_COLOR];
};

// Storage keys
export const STORAGE_KEYS = {
  yearGoals: 'zielplanung_year_goals',
  monthGoals: 'zielplanung_month_goals',
  weekGoals: 'zielplanung_week_goals',
  tasks: 'zielplanung_tasks',
  dayFocus: 'zielplanung_day_focus',
  appointments: 'zielplanung_appointments',
  googleCalendars: 'zielplanung_google_calendars',
  googleTokens: 'zielplanung_google_tokens',
  syncedAppointments: 'zielplanung_synced_appointments',
  testModalShown: 'zielplanung_test_modal_shown',
  yearPlanning: 'zielplanung_year_planning',
  dailyTodos: 'zielplanung_daily_todos',
  weeklyTodos: 'zielplanung_weekly_todos',
  monthlyTodos: 'zielplanung_monthly_todos',
  backlogTodos: 'zielplanung_backlog_todos'
};

// Google Calendar Config
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
export const GOOGLE_SCOPES = [
  'https://www.googleapis.com/auth/calendar.readonly',
  'https://www.googleapis.com/auth/calendar.events'
].join(' ');
